// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__27Ufq","location":"Header_location__3q9-j"};